import { ROTULO_ALTERNAR_TEMA } from '@/constants/tema.constants';
import { useTema } from '@/hooks/use-tema';

/**
 * Botão de troca de tema.
 *
 * Mostra o destino, não o estado atual: no tema claro aparece a lua, porque é para lá
 * que o clique leva. O ícone é decorativo — quem usa leitor de tela ouve o rótulo.
 */

const IconeLua = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="size-[15px]"
  >
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" />
  </svg>
);

const IconeSol = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="size-[15px]"
  >
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
  </svg>
);

export const AlternadorTema = () => {
  const { tema, alternar } = useTema();
  const escuro = tema === 'escuro';
  const rotulo = ROTULO_ALTERNAR_TEMA[tema];

  return (
    <button
      type="button"
      onClick={alternar}
      aria-label={rotulo}
      title={rotulo}
      className="grid size-8 flex-none place-items-center rounded-lg text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
    >
      {escuro ? <IconeSol /> : <IconeLua />}
    </button>
  );
};
